module.exports = __webpack_public_path__ + "img/FO.8f009344.svg";